import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HelperService } from '../../helper.service';
import { MappingComponent } from '../../mapping/mapping.component';
import { RainMeters } from '../../models/rainMeters';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';


@Component({
    selector: 'app-rain-meter-selection',
    templateUrl: './rain-meter-selection.component.html',
    styleUrls: ['./rain-meter-selection.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class RainMeterSelectionComponent implements OnInit {

  rainMeters: RainMeters[];
  currentLocation: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<MappingComponent>,
    private helper: HelperService,
    public translate: TranslateService
  ) {

  }

  ngOnInit(): void {
    if (this.data != null) {
      if (this.data.rainMeters != null) {
        this.rainMeters = this.data.rainMeters;
        if ('geolocation' in navigator) {
          navigator.geolocation.getCurrentPosition((position) => {
            for (var i = 0; i < this.rainMeters.length; i++) {
              var meterLocation = JSON.parse(this.rainMeters[i].location).coordinates;
              this.currentLocation = position;
              this.rainMeters[i].distance = this.helper.getDistanceFromLatLonInM(meterLocation[1], meterLocation[0], position.coords.latitude, position.coords.longitude);
            }
          });
        }
      }
    }
  }

  sortByName() {
    this.rainMeters.sort((a, b) => a.name.localeCompare(b.name));
  }

  sortByDistance() {
    this.rainMeters.sort((a, b) => a.distance - b.distance);
  }

  selectRainMeter(id, name) {
    this.dialogRef.close({ "id": id, "name": name });
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
